import InsuranceView from './InsuranceView';

export default InsuranceView;
